import { render, staticRenderFns } from "./VirtualAgentsSessionsSectionSearch.vue?vue&type=template&id=2442c77a&scoped=true&"
import script from "./VirtualAgentsSessionsSectionSearch.vue?vue&type=script&lang=js&"
export * from "./VirtualAgentsSessionsSectionSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2442c77a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
